import { Injectable } from '@angular/core';
import { API } from 'aws-amplify';
import { Observable, from } from 'rxjs';
import { environment } from 'src/environments/environment';

export const COMPANY_STRIPE_PS_API_NAME: string = 'company_stripe_ps';
export const COMPANY_STRIPE_PS_API_ENDPOINT: string = environment.API_BASE_PATH + '/company-stripe-payment-source';

@Injectable({
  providedIn: 'root',
})
export class CompanyStripePaymentSourceService {
  listCompanyStripePaymentSources(company_id: string): Observable<any> {
    const api_name: string = COMPANY_STRIPE_PS_API_NAME;
    const path: string = `/company/${company_id}`;
    const init = { response: true };
    return from(API.get(api_name, path, init));
  }

  deleteCompanyStripePaymentSource(company_id: string, csps_id: string): Observable<any> {
    const api_name: string = COMPANY_STRIPE_PS_API_NAME;
    const path: string = `/${csps_id}/company/${company_id}`;
    const init = { response: true };
    return from(API.del(api_name, path, init));
  }
}

export class CompanyStripePaymentSource {
  company_stripe_payment_source_id?: string;
  company_id?: string;
  livemode?: boolean;
  type?: StripePaymentSourceType;
  stripe_payment_method_id?: string;
  stripe_card?: StripeCard;
  stripe_sepa_debit?: StripeSepaDebit;
  is_default_source?: boolean;
}

export class StripeCard {
  fingerprint?: string;
  brand?: string;
  country?: string;
  exp_month?: number;
  exp_year?: number;
  last4?: string;
  funding?: StripePaymentSourceFunding;
}

export class StripeSepaDebit {
  fingerprint?: string;
  bank_code?: string;
  country?: string;
  last4?: string;
}

export enum StripePaymentSourceType {
  card = 'card',
  account = 'sepa_debit',
}

export enum StripePaymentSourceFunding {
  prepaid = 'prepaid',
  debit = 'debit',
  credit = 'credit',
}
